const debug = require('debug')('streamspot:debugging');

export const debugDump = (propsPlayer, statePlayer) => {
  debug('***** Player from Props or this *****');
  if (propsPlayer) {
    debugPlayer(propsPlayer);
  }
  //debug('***** Player from State *****');
  if (statePlayer) {
    //debugPlayer(propsPlayer);
  }
  //debug('***** Player from Window *****');
  if (window.Player) {
    //debugPlayer(window.Player);
  }
};

const debugPlayer = (player) => {
  //debug('** player **');
  //debug(player);

  //debug('** player.qs **');
  //debug(player.qs);

  debug('** player.api **');
  debug(player.api);

  //debug('** player.config **');
  //debug(player.config);

  //debug('** player.broadcaster **');
  //debug(player.broadcaster)

  //debug('** Other Properties **');
  /**
  debug({
    chromecast: player.chromecast,
    playlist: player.playlist,
    internal: player.internal,
    byBroadcastor: player.byBroadcastor,
    baseOverlay: player.baseOverlay,
    switchingHlsLevels: player.switchingHlsLevels,
    playOverlay: player.playOverlay,
    audioOnly: player.audioOnly,
    backgroundOverlay: player.backgroundOverlay,
    util: player.util,
    lock: player.lock,
    disableMenu: player.disableMenu,
    videos: player.videos,
    usedCategories: player.usedCategories,
    mobile: player.mobile,
    phone: player.phone,
    tablet: player.tablet,
    userAgent: player.userAgent,
    os: player.os,
    categories: player.categories,
    broadcasts: player.broadcasts,
    state: player.state,
    overlay: player.overlay,
    currentVideo: player.currentVideo,
    currentResolution: player.currentResolution,
    menu: player.menu,
    church: player.church,
  });
  **/
}



// WEBPACK FOOTER //
// ./src/util/debug.js